export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20 bg-gradient-to-br from-amber-50 via-white to-orange-50">
      <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-white/60"></div>
      <div className="relative max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                <span style={{ color: 'rgb(194, 65, 12)', fontStyle: 'italic', fontSize: '3.75rem' }}>新鮮</span>越南水果
                <br />
                <span className="text-orange-700 italic">優質</span>出口全球
              </h1>
              <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
                我們專注於越南熱帶水果的出口業務,擁有完善的供應鏈體系和嚴格的品質控制標準,為全球客戶提供最新鮮、最優質的熱帶水果。
              </p>
            </div>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollTo("products")}
                className="px-8 py-3.5 bg-orange-700 text-white font-medium rounded-full hover:bg-orange-800 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                查看產品
              </button>
              <button
                onClick={() => scrollTo("about")}
                className="px-8 py-3.5 border-2 border-orange-700 text-orange-700 font-medium rounded-full hover:bg-orange-50 transition-all whitespace-nowrap cursor-pointer"
              >
                了解更多
              </button>
            </div>
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="space-y-1">
                <div className="text-3xl font-bold text-orange-700">15+</div>
                <div className="text-sm text-gray-600">出口國家</div>
              </div>
              <div className="space-y-1">
                <div className="text-3xl font-bold text-orange-700">500+</div>
                <div className="text-sm text-gray-600">合作客戶</div>
              </div>
              <div className="space-y-1">
                <div className="text-3xl font-bold text-orange-700">15年</div>
                <div className="text-sm text-gray-600">行業經驗</div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                alt="越南熱帶水果"
                className="w-full h-full object-cover object-top"
                src="https://storage.readdy-site.link/project_files/30f8f242-a15b-40e7-aba5-0fa55946b4a0/e36c856d-b9f1-46d4-a1c9-cbccfe7659e2_WhatsApp-Image-2026-03-23-at-4.47.13-PM.jpeg?v=20887e8d0c67a65fb657016afd8fc448"
              />
              <div className="absolute top-6 right-6 bg-white rounded-full px-6 py-3 shadow-lg">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-orange-500 rounded-full animate-pulse"></div>
                  <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">100% 越南製造</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
